import React, { useEffect, useState } from 'react';
import lodash from 'lodash';
import { get, map, template, join } from 'lodash';
import { connect } from 'react-redux';
import StudyUsersTeamTable from './StudyUsersTeamTable';
import { waitingForLoadExternalUsers, removeStudyMonitor } from 'pages/studyOverview/actions/studySettings';
import { binderInstitutionIdSelector } from 'common/selectors';
import { getTimezoneOffset } from 'common/selectors/index';
import { loadExternalUsersForStudyWithPagination } from 'pages/studyOverview/actions/studySettings';
import { addOrEditStudyMonitor } from 'pages/studyOverview/actions/studySettings';
import * as dateTimeUtils from 'common/util/dateTime';
import AddMonitorModal from '../../components/AddMonitorsModal';
import { actions, features, canAccessStudyPermissions } from 'common/permissions/studyPredicates';
import styles from './StudyUsers.scss';


const DEFAULT_FILTER = { search: '', filter: {}, sort: { key: 'accessStart', value: 'ASC' }, initial: true };

export function StudyUsersMonitors(props) {
    const {
        study,
        loadExternalUsersForStudyWithPagination,
        studyMonitorsPagination,
        studyMonitorsPaginationCount,
        addOrEditStudyMonitor,
        binderId,
        institutionId,
        timezoneOffset,
        waitingForLoadExternalUsers,
        removeStudyMonitor,
        studyPermissions
    } = props;

    const [filterRecord, setFilterRecord] = useState(DEFAULT_FILTER);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [paginationdata, setPagination] = useState({ limit: 25, offset: 0, totalCount: 0 });
    const [isAddMonitorModalShowing, showAddMonitorModal] = useState(false);
    const [editMonitor, setEditMonitor] = useState({});

    useEffect(() => {
        let sortField;
        let sortOrder = filterRecord.sort.value.toString() || '';
        if (filterRecord.sort.key === 'displayName') {
            sortField = 'displayName';
        } else if (filterRecord.sort.key === 'accessStart') {
            sortField = 'startDate';
        } else {
            sortField = 'endDate';
        }
        loadExternalUsersForStudyWithPagination(study.binderId, study.institutionId, { limit: paginationdata.limit, offset: paginationdata.offset, sortOrder: sortOrder === 'ASC' ? 'ASC' : 'DESC', sortField: sortField, queryText: filterRecord.search });
    }, [isAddMonitorModalShowing]);

    useEffect(() => {
        setPagination({ ...paginationdata, totalCount: studyMonitorsPaginationCount });
        setRows(gatherTeamData(studyMonitorsPagination));
        setColumns(buildMonitorColumns());
        return () => {
            setRows([]);
            setColumns([]);
        };
    }, [studyMonitorsPagination]);

    const addMonitorToStudy = externalUser => {
        addOrEditStudyMonitor(
            {
                firstName: externalUser.firstName,
                lastName: externalUser.lastName,
                displayName: `${externalUser.firstName} ${externalUser.lastName}`,
                emailAddress: externalUser.emailAddress,
            },
            binderId,
            institutionId,
            dateTimeUtils.formatDateAndTimeForSave(externalUser.startDate, externalUser.startTime, timezoneOffset),
            dateTimeUtils.formatDateAndTimeForSave(externalUser.endDate, externalUser.endTime, timezoneOffset),
            {
                notify: externalUser.notify,
                edit: !lodash.isEmpty(editMonitor),
                paginationdata: paginationdata,
                filterRecord: filterRecord
            },
        );
        showAddMonitorModal(false);
        waitingForLoadExternalUsers(true);
        setEditMonitor({});
    };

    const handleRowClick = (monitorData) => {
        setEditMonitor(monitorData);
        showAddMonitorModal(true);
    };

    const gatherTeamData = (studyMonitorsPagination) => {
        let sortedData = studyMonitorsPagination;
        return map(sortedData, (studyMonitor) => {
            const startDateTime = new Date(get(studyMonitor, ['startDate']) + 'T' + get(studyMonitor, ['startTime']));
            const formattedStartDate = template('<%= date %> <%= time %>')({
                date: join([startDateTime.getDate(), startDateTime.toLocaleString('en-US', { month: 'short' }).replace(/^(\w{1})/, match => match.toUpperCase()), startDateTime.getFullYear()], ' '),
                time: startDateTime.toLocaleString('en-US', { hour: 'numeric', minute: '2-digit' }),
            });

            const endDate = get(studyMonitor, ['endDate']);
            const endTime = get(studyMonitor, ['endTime']);

            let formattedEndDate;
            if (endDate) {
                const endDateTime = new Date(endDate + 'T' + endTime);
                formattedEndDate = template('<%= date %> <%= time %>')({
                    date: join([endDateTime.getDate(), endDateTime.toLocaleString('en-US', { month: 'short' }).replace(/^(\w{1})/, match => match.toUpperCase()), endDateTime.getFullYear()], ' '),
                    time: endDateTime.toLocaleString('en-US', { hour: 'numeric', minute: '2-digit' }),
                });
            } else {
                formattedEndDate = 'Indefinite';
            }


            return {
                id: lodash.get(studyMonitor, ['id']),
                sub: lodash.get(studyMonitor, ['sub']),
                displayName: lodash.get(studyMonitor, ['displayName']),
                monitorEmailAddress: lodash.get(studyMonitor, ['emailAddress']),
                accessStart: formattedStartDate,
                accessEnd: formattedEndDate,
                firstName: lodash.get(studyMonitor, ['firstName']),
                lastName: lodash.get(studyMonitor, ['lastName']),
                emailAddress: lodash.get(studyMonitor, ['emailAddress']),
                startDate: lodash.get(studyMonitor, ['startDate']),
                startTime: lodash.get(studyMonitor, ['startTime']),
                endDate: lodash.get(studyMonitor, ['endDate']),
                endTime: lodash.get(studyMonitor, ['endTime']),
            };
        });
    };

    const buildMonitorColumns = () => {
        const monitorColumns = [
            {
                title: 'Name',
                field: 'displayName',
                searchPlaceholder: 'Monitors',
                hidden: false,
                headerStyle: {
                    width: '70%',
                    minWidth: '70%',
                },
                cellStyle: {
                    width: '70%',
                    minWidth: '70%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
                toolbarSearch: true,
            },
            {
                title: 'Email',
                field: 'monitorEmailAddress',
                hidden: false,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                },
                cellStyle: {
                    width: 'auto',
                    maxWidth: '50%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    cursor: 'pointer',
                    color: 'var(--blue-500, #2057AD)',
                },
                render: rowData => (
                    <a href={`mailto:${rowData.monitorEmailAddress}`} className={styles.emailAddress}>
                        {rowData.monitorEmailAddress}
                    </a>
                ),
            }, {
                title: 'Access Start',
                field: 'accessStart',
                hidden: false,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                },
                cellStyle: {
                    width: '10%',
                    minWidth: '10%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
                toolbarSort: 'ASC',
                toolbarDefaultSort: true,
                singleSort: true,
            },
            {
                title: 'Access End',
                field: 'accessEnd',
                hidden: false,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                },
                cellStyle: {
                    width: '10%',
                    minWidth: '10%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
                toolbarSort: 'ASC',
                toolbarDefaultSort: false,
                singleSort: true
            },
            {
                title: 'createButton',
                field: 'createButton',
                createButton: true,
                hidden: true,
                label: 'Add Monitor',
                execute: () => showAddMonitorModal(true),
                isCreateAllowed: canAccessStudyPermissions(studyPermissions, actions.MANAGE, features.MONITORS) || canAccessStudyPermissions(studyPermissions, actions.MANAGE, features.USERS),
            },
            {
                title: 'Name',
                field: 'displayName',
                hidden: true,
                toolbarSearch: true,
                toolbarSort: 'ASC',
                toolbarDefaultSort: false,
                singleSort: false
            },
            {
                title: 'id',
                field: 'id',
                hidden: true,
            },
            {
                title: 'sub',
                field: 'sub',
                hidden: true,
            },
        ];

        return monitorColumns;
    };

    const onFilterChange = (filterRecords = filterRecord, pagination = paginationdata) => {
        if (filterRecords) {
            setFilterRecord(filterRecords);
            let sortOrder = filterRecords ? filterRecords.sort.value.toString() : '';
            let queryText = filterRecords ? filterRecords.search : '';
            let sortField;
            if (filterRecords.sort.key === 'displayName') {
                sortField = 'displayName';
            } else if (filterRecords.sort.key === 'accessStart') {
                sortField = 'startDate';
            } else {
                sortField = 'endDate';
            }

            loadExternalUsersForStudyWithPagination(study.binderId, study.institutionId, {
                queryText: queryText,
                sortOrder: sortOrder === 'ASC' ? 'ASC' : 'DESC',
                sortField: sortField,
                limit: pagination.limit,
                offset: pagination.offset,
            });
        }
    };

    const showZeroStateForFilter = (
        (Object.values(filterRecord.search).length > 0) &&
        studyMonitorsPagination.length === 0
    );

    return (
        <div>
            <StudyUsersTeamTable
                onFilterUpdate={onFilterChange}
                filterRecord={filterRecord}
                setFilterRecord={setFilterRecord}
                rows={rows}
                columns={columns}
                pagination={paginationdata}
                footerLabel='users'
                setPagination={setPagination}
                onChangePagination={(pagination) => onFilterChange(filterRecord, pagination)}
                handleRowClick={handleRowClick}
                isEditAllowed={canAccessStudyPermissions(studyPermissions, actions.MANAGE, features.MONITORS) || canAccessStudyPermissions(studyPermissions, actions.MANAGE, features.USERS)}
                isRemoveAllowed={canAccessStudyPermissions(studyPermissions, actions.MANAGE, features.MONITORS) || canAccessStudyPermissions(studyPermissions, actions.MANAGE, features.USERS)}
                showZeroStateForFilter={showZeroStateForFilter}
            />
            {isAddMonitorModalShowing && <AddMonitorModal
                dismiss={isAddMonitorModalShowing}
                onAction={addMonitorToStudy}
                editMonitor={editMonitor}
                onDismiss={() => {
                    setEditMonitor([]);
                    showAddMonitorModal(false);
                }}
                removeMonitor={removeStudyMonitor}
            />}
        </div>
    );

}

export default connect(state => {
    const study = lodash.get(state, 'study', null);
    const binderId = lodash.get(state, 'binder.id', {});
    const institutionId = binderInstitutionIdSelector(state);
    const timezoneOffset = getTimezoneOffset(state);
    const studyMonitors = lodash.get(state, 'externalUsersForStudy', []);
    const loadingStudyMonitors = lodash.get(state, 'externalUsersForStudyLoading', false);
    const studyMonitorsPagination = lodash.get(state, 'externalUsersForStudyWithPagination', []);
    const studyMonitorsPaginationCount = lodash.get(state, 'externalUsersForStudyCount', []);
    const studyPermissions = lodash.get(state, 'me.studyPermissions', {});
    return {
        study,
        binderId,
        institutionId,
        loadingStudyMonitors,
        studyMonitors,
        studyMonitorsPagination,
        studyMonitorsPaginationCount,
        timezoneOffset,
        studyPermissions,
    };
}, {
    addOrEditStudyMonitor,
    waitingForLoadExternalUsers,
    removeStudyMonitor,
    loadExternalUsersForStudyWithPagination
}
)(StudyUsersMonitors);